



.socials
{
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: left;

  .title {
    white-space: nowrap;
  }

  .icons {
    display: flex;
    gap: 15px;
  }
}
.link {
  cursor: pointer;
}



.copied
{
  position: relative;
  &:after {
    content: attr(data-copytext);
    padding: 5px;
    max-width: 250px;
    width: max-content;
    text-wrap: avoid;
    border: 1px solid var(--beigedarker);
    position: absolute;
    top: 20px;
    right: 0;
    background: rgba(255, 255, 255, 0.91);
    border-radius: var(--border-radius);
    color: var(--beigedarker);
    box-shadow: 0 3px 7px 5px rgba(0, 0, 0, 0.03);
    z-index: 99999;
  }
}
